export default {

    preencher(inicial, referencia) {
        Object.keys(referencia).forEach(key => {
            inicial[key] = referencia[key]
        })
    },

}
